.wrapper {
  display: flex;
  flex-shrink: 0;
  align-items: center;

  &.hidden {
    display: none;
  }
}
